/* global Cookies, attachEvent, slideToggle */

const cookieElement = document.querySelector('.cookie-banner');
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : '';
};

const loadScripts = () => {
  const scripts = document.querySelectorAll('.sp-cookies.gtm');
  scripts.forEach((script) => {
    // eslint-disable-next-line no-param-reassign
    script.type = getCookie('cookie-analytics') === 'true' ? 'text/javascript' : 'text/plain';
    document.head.appendChild(script);
  });
};

const deleteAllCookiesExceptBannerSeen = () => {
  const cookies = document.cookie.split(';');
  const domainName = window.location.hostname.split('.').slice(-2).join('.');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    if (name !== 'cookie-banner-seen') {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${domainName}`;
    }
  }
};

if (cookieElement) {
  if (!Cookies.get('cookie-banner-seen')) {
    cookieElement.classList.add('cookie-not-set');
  }
  const domainName = window.location.hostname.split('.').slice(-2).join('.');
  attachEvent('.btn--cookie', 'click', (ev) => {
    ev.preventDefault();
    if (cookieElement.querySelector('#analytics').checked) {
      Cookies.set('cookie-analytics', 'true', { expires: 7, domain: domainName });
      loadScripts();
    }
    Cookies.set('cookie-banner-seen', 'cookie-set', { expires: 7, domain: domainName });
    cookieElement.classList.remove('cookie-not-set');
  });
}

if (!cookieElement) {
  loadScripts();
}

// **************************************************
// Open checkboxes
// **************************************************

const cookieOpen = document.querySelector('.open-cookie-settings');

if (cookieOpen) {
  cookieOpen.addEventListener('click', () => {
    const cookieCheckboxes = document.querySelector('.cookie-banner__checkboxes');
    slideToggle(cookieCheckboxes, 300, 'flex');
  });
}
